<!-- This component is used when you open the Ticket Picker and there is already a session chosen (as opposed to
normal when you pick the tickets first then a session). This happens if you come from the Today View, or if you use
the plus button to add more tickets for a session already in the cart. -->
<template>
    <div data-component="TicketPickerSession"
         class="ticket-picker-session">
        <SessionInfo v-if="session && event"
                     :session="session"
                     :event="event"
                     :availability="availability"
                     :show-event-name="false"
                     :spaces-required="spacesRequired"></SessionInfo>
    </div>
</template>

<script>
import SessionInfo from '@/epos/vue/modals/SessionPicker/SessionInfo';
import { container } from '@/container';

export default {
    name: 'TicketPickerSession',

    components: {
        SessionInfo,
    },

    props: {
        session: {
            type: Object,
            required: true,
        },

        spacesRequired: {
            type: Number,
            default: null,
        },
    },

    data() {
        return {
            // The Ticker Picker doesn't pass the event in. We have to load it ourselves.
            event: null,

            /**
             * @type {SessionAvailability}
             */
            availability: null,
        };
    },

    created() {
        container.sessionEventRepository.find(this.session.eventID)
            .then((event) => {
                this.event = event;
            })
            .catch((err) => {
                // Event not found 🤔.
                console.error('Failed to load event ', this.session.eventID, err);
            });

        container.sessionAvailabilityService
            .loadSessionAvailabilities(
                [this.session],
                null,
                container.cartService.currentCart.getOriginalOrderID()
            )
            .then((availabilities) => {
                if (availabilities && availabilities.hasOwnProperty(this.session.ID)) {
                    this.availability = availabilities[this.session.ID];
                    this.applySpacesInCartToAvailability();
                }
            })
            .catch(() => {
                // Failed to load availability. Maybe we're offline.
                // It's not a big deal. Just don't show the spaces.
            });
    },

    methods: {
        applySpacesInCartToAvailability() {
            if (this.availability) {
                container.sessionSpaceCalculatorFactory
                    .create()
                    .applySpacesInCartToAvailability(this.availability);
            }
        },
    },
};
</script>

<style lang="less">
@import (reference) "../../../../less/variables.less";

.ticket-picker-session {
    background: @dt-light-grey;
    padding: @gutter-width;
    font-size: @font-size-medium;
}
</style>
